import DriedFruitsProduct from 'models/DriedFruitsProduct'

export const packagingInitialState = {
  category: DriedFruitsProduct.category,
  subCategory: DriedFruitsProduct.subCategory,
  type: {
    value: '',
    label: 'Type',
  },
  packageType: {
    value: '',
    label: 'Package Type',
  },
  DFSize: '',
  isOrganic: false,
  MultiPackageType: false,
  MultiPackageCount: '',
  NoAdditionalIngredients: false,
  otherType: '',
  otherPackageType: '',
}

export const driedFruitsTypeOptions = [
  {
    value: '',
    label: 'Dried Fruit Type',
    isDisabled: true,
  },
  { value: 'Apple', label: 'Apple' },
  { value: 'Apricot', label: 'Apricot' },
  { value: 'Banana', label: 'Banana' },
  { value: 'Berry, Mixed', label: 'Berry, Mixed' },
  { value: 'Blackberry', label: 'Blackberry' },
  { value: 'Blueberry', label: 'Blueberry' },
  { value: 'Cantaloupe', label: 'Cantaloupe' },
  { value: 'Cherry', label: 'Cherry' },
  { value: 'Chilies', label: 'Chilies' },
  { value: 'Clementine', label: 'Clementine' },
  { value: 'Cranberry', label: 'Cranberry' },
  { value: 'Currants', label: 'Currants' },
  { value: 'Dates', label: 'Dates' },
  { value: 'Figs', label: 'Figs' },
  { value: 'Fruit, Mixed', label: 'Fruit, Mixed' },
  { value: 'Grapefruit', label: 'Grapefruit' },
  { value: 'Grapes', label: 'Grapes' },
  { value: 'Guava', label: 'Dates' },
  { value: 'Kiwi', label: 'Kiwi' },
  { value: 'Lemon', label: 'Lemon' },
  { value: 'Lime', label: 'Lime' },
  { value: 'Mango', label: 'Mango' },
  { value: 'Mulberry', label: 'Mulberry' },
  { value: 'Nectarine', label: 'Nectarine' },
  { value: 'Orange', label: 'Orange' },
  { value: 'Papaya', label: 'Papaya' },
  { value: 'Passionfruit', label: 'Passionfruit' },
  { value: 'Peach', label: 'Peach' },
  { value: 'Pear', label: 'Pear' },
  { value: 'Pepper', label: 'Pepper' },
  { value: 'Pineapple', label: 'Pineapple' },
  { value: 'Plum', label: 'Plum' },
  { value: 'Pluot', label: 'Pluot' },
  { value: 'Pomegranate', label: 'Pomegranate' },
  { value: 'Prune', label: 'Prune' },
  { value: 'Raisins', label: 'Raisins' },
  { value: 'Raspberry', label: 'Raspberry' },
  { value: 'Strawberry', label: 'Strawberry' },
  { value: 'Tangelo', label: 'Tangelo' },
  { value: 'Tangerine', label: 'Tangerine' },
  { value: 'Watermelon', label: 'Watermelon' },
  { value: 'Youngberries', label: 'Youngberries' },
  { value: 'Other', label: 'Other' },
]

export const packageTypeOptions = [
  {
    value: '',
    label: 'Package Type',
    isDisabled: true,
  },
  { value: 'Bag', label: 'Bag' },
  { value: 'Box', label: 'Box' },
  { value: 'Canister', label: 'Canister' },
  { value: 'Freeze Dried', label: 'Freeze Dried' },
  { value: 'Plastic Tub', label: 'Plastic Tub' },
  { value: 'Tray', label: 'Tray' },
  { value: 'Other', label: 'Other' },
]
